import db from "../../firebase";
import { doc, updateDoc, collection, getDocs } from "firebase/firestore";

import { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  updateAdminSuccessMsg,
  updateAdminActiveCelebList,
} from "../../store/actions";

import {
  Box,
  Paper,
  Switch,
  Avatar,
  Table,
  TableHead,
  TableBody,
  TableContainer,
  TableRow,
  TableCell,
  IconButton,
  Typography,
} from "@mui/material";

import EditIcon from "@mui/icons-material/Edit";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

import cld from "../../cloudinary";

import ModalCard from "./ModalCard";
import SingleCard from "./SingleCard";

export default function VerificationSection({ currentScreenWidth }) {
  const dispatch = useDispatch();
  const celebData = useSelector((state) => state.celebData);

  const [activeAdminCelebImages, setActiveAdminActiveCelebImages] = useState();
  const [activeAdminCelebModal, setActiveAdminCelebModal] = useState(false);
  const [editActiveCelebImageData, setEditActiveCelebImageData] = useState();

  const adminActiveCelebList = useSelector(
    (state) => state.adminActiveCelebList
  );

  // verify celeb
  const updateVerified = (e, item) => {
    updateDoc(doc(db, "biddify", item.id), {
      verified: e.target.checked,
    });
    dispatch(
      updateAdminSuccessMsg(
        e.target.checked
          ? `${item.name} Verified Successfully!`
          : `${item.name} Unverified Successfully!`
      )
    );
    setTimeout(() => dispatch(updateAdminSuccessMsg("")), 1000);
  };

  const activeCelebFn = (item) => {
    const temp = [];
    async function getData() {
      return await getDocs(collection(db, `biddify/${item.id}/gallery`));
    }
    getData().then((docs) => {
      docs.forEach((doc) => {
        temp.push({
          id: doc.data().id,
          image: cld.image(doc.data().public_id).toURL(),
        });
      });
      setActiveAdminActiveCelebImages(temp);
      dispatch(updateAdminActiveCelebList(item.id));
    });
  };

  return (
    <>
      <Box
        component={Paper}
        elevation={3}
        sx={{
          marginBottom: "20px",
          padding: "15px",
          display: "flex",
          alignItems: "center",
        }}
      >
        {adminActiveCelebList !== "" && (
          <IconButton
            edge="end"
            aria-label="delete"
            sx={{ marginRight: "10px", padding: "0" }}
            onClick={() => dispatch(updateAdminActiveCelebList(""))}
          >
            <ArrowBackIcon />
          </IconButton>
        )}
        <Typography>
          {adminActiveCelebList === ""
            ? "Celebrities"
            : celebData.filter((item) => item.id === adminActiveCelebList)[0]
                .name}
        </Typography>
      </Box>{" "}
      {adminActiveCelebList === "" ? (
        <TableContainer component={Paper} elevation={3} sx={{ pb: 2 }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>S.No.</TableCell>
                <TableCell>Image</TableCell>
                <TableCell>Name</TableCell>
                <TableCell>Handle</TableCell>
                <TableCell>Followers</TableCell>
                <TableCell>Verified</TableCell>
                <TableCell>Edit</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {celebData.map((item, index) => (
                <TableRow key={index}>
                  <TableCell component="th" scope="row">
                    {index + 1}
                  </TableCell>
                  <TableCell>
                    <Avatar alt="" src={cld.image(item.public_id).toURL()} />
                  </TableCell>
                  <TableCell>{item.name}</TableCell>
                  <TableCell>{item.handle}</TableCell>
                  <TableCell>{item.followers}M</TableCell>
                  <TableCell>
                    <Switch
                      sx={{
                        "& .MuiSwitch-switchBase.Mui-checked": {
                          color: "#ec004f",
                        },
                        "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track":
                          {
                            backgroundColor: "#ec004f",
                          },
                      }}
                      defaultChecked={item.verified ? true : false}
                      onChange={(e) => updateVerified(e, item)}
                    />
                  </TableCell>
                  <TableCell>
                    <IconButton onClick={() => activeCelebFn(item)}>
                      <EditIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      ) : (
        activeAdminCelebImages.map((item, index) => (
          <SingleCard
            key={index}
            item={item}
            setActiveAdminCelebModal={setActiveAdminCelebModal}
            currentScreenWidth={currentScreenWidth}
            setEditActiveCelebImageData={setEditActiveCelebImageData}
          />
        ))
      )}
      <ModalCard
        activeAdminCelebModal={activeAdminCelebModal}
        setActiveAdminCelebModal={setActiveAdminCelebModal}
        editActiveCelebImageData={editActiveCelebImageData}
        setEditActiveCelebImageData={setEditActiveCelebImageData}
      />
    </>
  );
}
